import React from "react";
import SectionTitle from "./section-title";
import Container from "./container";

const OurClients = ({ images }) => {
  return (
    <Container className={"px-5 py-5 space-y-10 md:space-y-14"}>
      <SectionTitle title={"Meet Our Clients"} />
      <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-4">
        {images.map((logo, idx) => {
          return (
            <div
              key={idx}
              className="bg-white rounded-lg shadow-md p-4 transition-transform duration-300 hover:scale-105 hover:shadow-lg"
            >
              <div className="aspect-square w-full max-w-[80px] md:max-w-[120px] mx-auto">
                <img
                  src={logo?.url}
                  alt="client logo"
                  className="w-full h-full object-contain"
                />
              </div>
            </div>
          );
        })}
      </div>
    </Container>
  );
};

export default OurClients;
